var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('a-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h5', {
    staticClass: "mb-4"
  }, [_c('strong', [_vm._v("Auction details")])]), _c('div', {
    staticClass: "mb-2"
  }, [_c('status', {
    attrs: {
      "auction": _vm.auction
    }
  })], 1), _c('a-row', {
    staticClass: "mb-5"
  }, [['canceled', 'completed', 'closed'].indexOf(_vm.auction.status) === -1 ? _c('countdown', {
    attrs: {
      "startTime": _vm.moment(_vm.auction.startsAt).unix(),
      "endTime": _vm.moment(_vm.auction.endsAt).unix()
    },
    on: {
      "auctionStarted": _vm.startAuction,
      "auctionEnded": _vm.endAuction
    }
  }) : _vm._e()], 1), _c('a-row', {
    staticClass: "mb-2"
  }, [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("Auction status")]), _c('a-col', {
    staticClass: "text-right",
    attrs: {
      "span": 12
    }
  }, [_c('a-tag', {
    attrs: {
      "color": _vm.auction.status == 'canceled' ? 'red' : '#108ee9'
    }
  }, [_c('span', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm.auction.status))])])], 1)], 1), _c('a-row', {
    staticClass: "mb-2"
  }, [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("Auction direction")]), _c('a-col', {
    staticClass: "text-right",
    attrs: {
      "span": 12
    }
  }, [_c('a-tag', {
    attrs: {
      "color": "#070707"
    }
  }, [_c('span', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm.auction.flow == 'buy' ? 'Purchasing' : 'Selling'))])])], 1)], 1), _c('a-row', {
    staticClass: "mb-2"
  }, [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("Auction type")]), _c('a-col', {
    staticClass: "text-right",
    attrs: {
      "span": 12
    }
  }, [_c('a-tag', {
    attrs: {
      "color": "#108ee9"
    }
  }, [_c('span', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm.auction.type))])])], 1)], 1), _c('a-row', {
    staticClass: "mb-2"
  }, [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("Auction start")]), _c('a-col', {
    staticClass: "text-right",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.auctionStart))])], 1), _c('a-row', {
    staticClass: "mb-2"
  }, [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("Auction end")]), _c('a-col', {
    staticClass: "text-right",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.auctionEnd))])], 1), _c('a-row', {
    staticClass: "mb-2"
  }, [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("Auction name")]), _c('a-col', {
    staticClass: "text-right",
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.auction.name))])], 1), _c('a-row', {
    staticClass: "mb-2"
  }, [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("Allocation volume")]), _c('a-col', {
    staticClass: "text-right",
    attrs: {
      "span": 12
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.auction.allocationVolume))]), _vm._v(" MWh/h ")])], 1), _c('a-row', {
    staticClass: "mb-2"
  }, [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("Required collateral")]), _c('a-col', {
    staticClass: "text-right",
    attrs: {
      "span": 12
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.auction.requiredCollateral))]), _vm._v(" EUR ")])], 1), _c('div', {
    staticClass: "mb-3 mt-3"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Auction comment")]), _c('p', {
    staticClass: "auction-comment"
  }, [_vm._v(_vm._s(_vm.auction.comment))])]), _c('a-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [this.auction.allocationPattern.length > 0 && !_vm.flatPattern ? _c('LoadPattern', {
    attrs: {
      "pattern": this.auction.allocationPattern,
      "shouldReact": false
    }
  }) : _vm._e()], 1)], 1)], 1)])]), _c('a-col', {
    attrs: {
      "span": 16
    }
  }, [_vm.isSuperUser && this.auction.status == 'announced' ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', [_c('h5', {
    staticClass: "mb-4"
  }, [_c('strong', [_vm._v("Auction comment")])]), _c('div', {
    staticClass: "mb-3"
  }, [_c('a-textarea', {
    attrs: {
      "rows": 4,
      "placeholder": "Message visible to the customer on the auction screen"
    },
    model: {
      value: _vm.auction.comment,
      callback: function callback($$v) {
        _vm.$set(_vm.auction, "comment", $$v);
      },
      expression: "auction.comment"
    }
  })], 1), _c('a-space', {
    attrs: {
      "space": 16
    }
  }, [_c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateComment
    }
  }, [_vm._v("Update comment ")])], 1)], 1)])]) : _vm._e(), _vm.isSuperUser && this.auction.status == 'announced' ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h5', {
    staticClass: "mb-4"
  }, [_c('strong', [_vm._v("Participants")])]), _c('p', {
    staticClass: "font-weight-light mb-3"
  }, [_vm._v(" You can select or exclude participants from the list before the auction start. Please note that email will be sent to all users of invited participants automatically. ")]), _c('a-spin', {
    attrs: {
      "spinning": _vm.loadingParticipants
    }
  }, [_c('div', {}, [_c('a-table', {
    attrs: {
      "columns": _vm.participantColumns,
      "data-source": _vm.participants,
      "pagination": {
        pageSize: 50
      },
      "row-key": function rowKey(record) {
        return record.id;
      },
      "row-selection": {
        selectedRowKeys: _vm.participantIds,
        onChange: _vm.onParticipantSelectionChanged
      }
    }
  })], 1)])], 1)]) : _vm._e(), _c('div', {
    staticClass: "card"
  }, [_c('a-spin', {
    attrs: {
      "spinning": _vm.finalizing
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "clearfix mb-5"
  }, [_c('h5', {
    staticClass: "mb-4"
  }, [_c('strong', [_vm._v("Auction overview")])]), _c('div', {
    staticClass: "float-right"
  }, [_c('a-space', {
    attrs: {
      "space": 16
    }
  }, [_vm.isSuperUser && ['closed'].indexOf(this.auction.status) !== -1 ? _c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.completeAuction
    }
  }, [_vm._v("Finalize auction ")]) : _vm._e(), this.auction.status == 'live' ? _c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function click() {
        return _vm.createOrderFormVisible = !_vm.createOrderFormVisible;
      }
    }
  }, [_vm._v("Place New Order ")]) : _vm._e(), _vm.isSuperUser && ['announced', 'live', 'closed'].indexOf(this.auction.status) !== -1 ? _c('a-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.cancelAuction
    }
  }, [_vm._v("Cancel auction ")]) : _vm._e()], 1)], 1)]), _c('a-spin', {
    attrs: {
      "spinning": _vm.creatingOrder
    }
  }, [_vm.createOrderFormVisible ? _c('div', [_c('a-form-model', {
    ref: "bidForm",
    attrs: {
      "model": _vm.bid,
      "form": _vm.form,
      "layout": "vertical"
    },
    on: {
      "submit": _vm.createBid
    }
  }, [_vm.isSuperUser ? _c('a-form-model-item', {
    ref: "bidAmount",
    attrs: {
      "label": "Participant",
      "prop": "bidAmount"
    }
  }, [_c('a-select', {
    attrs: {
      "show-search": "",
      "placeholder": "Select participant",
      "option-filter-prop": "children",
      "filter-option": _vm.filterOption
    },
    on: {
      "change": _vm.handleParticipantChange
    },
    model: {
      value: _vm.bid.participantId,
      callback: function callback($$v) {
        _vm.$set(_vm.bid, "participantId", $$v);
      },
      expression: "bid.participantId"
    }
  }, _vm._l(_vm.assignedParticipants, function (participant) {
    return _c('a-select-option', {
      key: participant.id,
      attrs: {
        "value": participant.id
      }
    }, [_vm._v(" " + _vm._s(participant.name) + " ")]);
  }), 1)], 1) : _vm._e(), _c('a-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    ref: "bidAmount",
    attrs: {
      "label": "Amount",
      "prop": "bidAmount"
    }
  }, [_c('a-input', {
    attrs: {
      "type": "number",
      "step": "1",
      "placeholder": "Enter bid amount in MWh/h"
    },
    model: {
      value: _vm.bid.amount,
      callback: function callback($$v) {
        _vm.$set(_vm.bid, "amount", $$v);
      },
      expression: "bid.amount"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 12
    }
  }, [_c('a-form-model-item', {
    ref: "bidPrice",
    attrs: {
      "label": "Price per MWh",
      "prop": "bidPrice"
    }
  }, [_c('a-input', {
    attrs: {
      "placeholder": "Enter bid price per MWh/h in EUR"
    },
    model: {
      value: _vm.bid.price,
      callback: function callback($$v) {
        _vm.$set(_vm.bid, "price", $$v);
      },
      expression: "bid.price"
    }
  }), _vm.auction.minPrice ? _c('span', {
    staticClass: "text-default"
  }, [_vm._v("Min. " + _vm._s(_vm.auction.minPrice) + " EUR/MWh")]) : _vm._e(), _c('br'), _vm.auction.maxPrice ? _c('span', {
    staticClass: "text-default"
  }, [_vm._v("Max. " + _vm._s(_vm.auction.maxPrice) + " EUR/MWh")]) : _vm._e()], 1)], 1)], 1), _c('a-form-item', [_c('a-button', {
    staticClass: "btn btn-success pull-right",
    on: {
      "click": _vm.createBid
    }
  }, [_vm._v("Place order")])], 1)], 1)], 1) : _vm._e()]), _vm.isSuperUser ? _c('OrdersGraph', {
    attrs: {
      "auction": _vm.auction,
      "orders": _vm.myOrders
    }
  }) : _vm._e()], 1)])], 1)])], 1), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a-spin', {
    attrs: {
      "spinning": _vm.blockingOrders
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {}, [_c('h5', {
    staticClass: "mb-4"
  }, [_c('strong', [_vm._v(_vm._s(_vm.isSuperUser ? 'All Orders' : 'My Orders'))])]), _c('div', {
    staticClass: "float-right"
  }, [_c('a-space', {
    attrs: {
      "space": 16
    }
  }, [_vm.isSuperUser && ['completed'].indexOf(this.auction.status) !== -1 ? _c('a-button', {
    staticClass: "mb-4",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.downloadAuctionCsv
    }
  }, [_vm._v("Generate CSV ")]) : _vm._e(), _vm.isSuperUser && ['completed'].indexOf(this.auction.status) !== -1 ? _c('a-button', {
    staticClass: "mb-4",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.downloadAuctionPdf
    }
  }, [_vm._v("Generate report ")]) : _vm._e()], 1)], 1)]), _c('a-table', {
    attrs: {
      "columns": _vm.columns,
      "dataSource": _vm.ordersCombined,
      "rowKey": "id"
    },
    scopedSlots: _vm._u([{
      key: "participantDateAndTime",
      fn: function fn(text, record) {
        return _c('div', {}, [_c('div', {
          style: {
            'padding-left': record.type == 'participant' ? '0px' : '16px'
          }
        }, [_vm._v(" " + _vm._s(record.participantDateAndTime) + " ")])]);
      }
    }, {
      key: "actions",
      fn: function fn(text, record) {
        return _c('div', {}, [_vm.auction.status == 'live' && record.type != 'participant' ? _c('a', {
          on: {
            "click": function click($event) {
              return _vm.cancelOrder(record.id);
            }
          }
        }, [_c('i', {
          staticClass: "fe fe-trash text-danger",
          attrs: {
            "title": "Delete order"
          }
        })]) : _vm._e(), _vm.isSuperUser && _vm.auction.status == 'completed' && record.type == 'participant' ? _c('a-space', {
          attrs: {
            "space": 16
          }
        }, [_c('a', {
          staticClass: "text-danger",
          on: {
            "click": function click() {
              return _vm.sendParticipantReport(record.participant);
            }
          }
        }, [_c('a-icon', {
          attrs: {
            "type": "mail"
          }
        }), _vm._v(" Send PAR")], 1), _c('a', {
          staticClass: "text-primary",
          on: {
            "click": function click() {
              return _vm.generateParticipantReport(record.participant.id);
            }
          }
        }, [_c('a-icon', {
          attrs: {
            "type": "file-pdf"
          }
        }), _vm._v(" Download PAR")], 1)]) : _vm._e()], 1);
      }
    }, {
      key: "status",
      fn: function fn(text) {
        return _c('span', {
          class: {
            'font-size-12': true,
            badge: true,
            'badge-success': text === 'Accepted',
            'badge-danger': text === 'Rejected',
            'badge-warning': text === 'Partially accepted'
          }
        }, [_vm._v(_vm._s(text))]);
      }
    }])
  })], 1)])])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }